import React from 'react'
import AutocompleteBase, {
  TAutocompleteBaseChangeHandler,
  IAutocompleteBaseOption,
} from 'transfix-ui/components/AutocompleteBase'
import { makeStyles } from 'transfix-ui/core'
import { IScraperJobConfigurationMetadataFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationMetadataFragment'
import { useDefaultAutobiddersFilters } from 'apps/spot-quote-control-panel/hooks/useDefaultAutobiddersFilters'
import { TAutobiddersFiltersSchema } from 'apps/spot-quote-control-panel/schema/AutobiddersFiltersSchema'

interface IAutobiddersFilters {
  metadata: IScraperJobConfigurationMetadataFragment
  filters: TAutobiddersFiltersSchema
  setFilters: React.Dispatch<React.SetStateAction<TAutobiddersFiltersSchema>>
}

const useStyles = makeStyles(theme => ({
  filters: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1.5),
    position: 'relative',
    marginBottom: theme.spacing(2),
  },
  autocomplete: {
    width: theme.spacing(24),
  },
}))

export const AutobiddersFilters = ({ filters, metadata, setFilters }: IAutobiddersFilters) => {
  const classes = useStyles()
  const defaultValues = useDefaultAutobiddersFilters()

  const buildOptions = (names: string[] | null) => {
    if (names) {
      return names.map(name => {
        return { text: name, id: name } as IAutocompleteBaseOption
      })
    }
    return [{ text: '', id: '' } as IAutocompleteBaseOption]
  }

  const shipperNameHandler: TAutocompleteBaseChangeHandler = (_, newValue) => {
    if (newValue && !Array.isArray(newValue) && typeof newValue === 'object' && newValue.text) {
      setFilters({ ...filters, shipperNames: [newValue.text] })
    } else {
      setFilters({ ...filters, shipperNames: defaultValues.shipperNames })
    }
  }

  const tmsNameHandler: TAutocompleteBaseChangeHandler = (_, newValue) => {
    if (newValue && !Array.isArray(newValue) && typeof newValue === 'object' && newValue.text) {
      setFilters({ ...filters, tmsNames: [newValue.text] })
    } else {
      setFilters({ ...filters, tmsNames: defaultValues.tmsNames })
    }
  }

  const tmsNames: string[] | null = metadata?.tmsNames !== undefined ? metadata.tmsNames : null
  const shipperNames: string[] | null =
    metadata?.shipperNames !== undefined ? metadata.shipperNames : null

  const tmsOptions = buildOptions(tmsNames)
  const shipperOptions = buildOptions(shipperNames)

  return (
    <div className={classes.filters}>
      <div className={classes.autocomplete}>
        <AutocompleteBase
          onChange={tmsNameHandler}
          options={tmsOptions}
          value={filters.tmsNames[0]}
          placeholder='Search TMS'
        />
      </div>
      <div className={classes.autocomplete}>
        <AutocompleteBase
          onChange={shipperNameHandler}
          options={shipperOptions}
          value={filters.shipperNames[0]}
          placeholder='Search Shipper'
        />
      </div>
    </div>
  )
}
